import React from 'react';
import { Box, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { ProjectCard } from './ProjectCard';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
const projects = [{
  title: 'BookSleeper',
  description: 'Audiobook app with a sleep timer and queue. Built it as a PWA so I could use it on my phone.',
  link: 'https://studio--booksleeper.us-central1.hosted.app/',
  tools: ['Firebase Studio', 'PWA'],
  gradient: 'linear(to-br, purple.400, purple.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rX79bHVPwZMHqRKrqqPRLA/booksleeper.webp',
  buildTime: '2 days'
}, {
  title: 'Thai Spot Booking',
  description: "Booking system for a Thai massage place with 4 locations. They had specific needs that regular booking systems didn't cover.",
  link: 'https://thai-spot-booking-randulamartin.replit.app',
  tools: ['Replit', 'Booking System', 'Prototype'],
  gradient: 'linear(to-br, pink.400, pink.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6drvywRBt7fUYio22CYVJ9/thaispot-booking.webp',
  buildTime: '1 day'
}, {
  title: 'Výletník',
  description: 'Travel planner with folders, distance tracking, and Google Places. Made it a PWA so I could use it offline.',
  link: 'https://studio--vletnk.us-central1.hosted.app/',
  tools: ['Firebase Studio', 'PWA', 'Google Places'],
  gradient: 'linear(to-br, teal.400, teal.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nxqmhnQBwcUnGVcEhzwo83/vyletnik.webp',
  buildTime: '3 weeks'
}, {
  title: 'Abugo Parking',
  description: 'Parking app for my company with admin section, user management, and Google Auth. You can book spots normally or just tell it what you want. Also works with Siri.',
  link: 'https://studio--abugo-parking.us-central1.hosted.app/',
  tools: ['Firebase Studio', 'N8N', 'API'],
  gradient: 'linear(to-br, blue.400, blue.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qcmnMe5amGi3hyxBQQgds/parking.webp',
  buildTime: '2 weeks'
}, {
  title: 'FENverter',
  description: 'Upload a screenshot from a chess game and it analyzes the position, creates FEN notation, evaluates it, and lets you easily open it in Lichess analysis.',
  link: 'https://fenverter.replit.app',
  tools: ['Replit', 'AI Vision', 'Chess'],
  gradient: 'linear(to-br, gray.600, gray.800)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pFan1ApDW9F7faFkai3G96/fenverter.webp',
  buildTime: '2 days'
}, {
  title: 'Google Feed to GPT Converter',
  description: 'Converts Google shopping feeds to GPT format. Quick prototype I threw together.',
  link: 'https://new-chat-zd8v.bolt.host/',
  tools: ['Bolt.new', 'Feed Converter'],
  gradient: 'linear(to-br, green.400, green.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/paZkdjRm8xoibnVSKxyNp9/google-feed-to-gpt-acp.webp',
  buildTime: '30 min'
}, {
  title: 'Desk Monitor Configurator',
  description: 'Try out different monitor setups in 2D and 3D before buying. Includes desk size and accessories.',
  link: 'https://desk-monitor-configu-7dug.bolt.host',
  tools: ['Bolt.new', 'Visualization', '3D'],
  gradient: 'linear(to-br, orange.400, orange.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dCjnbLQVd7kcvA9VWhQiUS/monitor-setup.webp',
  buildTime: '3 days'
}, {
  title: 'Dream Track',
  description: 'Sleep habit tracker with streaks and achievements. Trying to gamify better sleep.',
  link: 'https://nightowlchampion.lovable.app',
  tools: ['Replit', 'Gamification'],
  gradient: 'linear(to-br, indigo.400, indigo.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qysitbqktSVusvMpGcahX8/dreamtrack.webp',
  buildTime: '1 day'
}, {
  title: 'Convertim ROI Calculator',
  description: 'Calculator with admin section for sales data that shows potential ROI and pricing for Convertim. Helps businesses figure out if it makes sense for them.',
  link: 'https://convertim.cloud',
  tools: ['Bolt.new', 'Calculator'],
  gradient: 'linear(to-br, cyan.400, cyan.600)',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j599apHQw15KY3FzHFxHLq/roi-calculator.webp',
  buildTime: '3 days'
}];
export function ProjectsSection() {
  return <Box id="projects" as="section" py={10} mt={10} bg="gray.50" data-id="element-121">
      <MotionBox initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true
    }} data-id="element-122">
        <Heading as="h2" size="xl" mb={4} textAlign="center" data-id="element-123">
          My Projects
        </Heading>
        <Text textAlign="center" mb={8} color="gray.600" maxW="800px" mx="auto" data-id="element-124">
          Some things I've made using these tools.
        </Text>
        <SimpleGrid columns={{
        base: 1,
        md: 2,
        lg: 3
      }} spacing={6} data-id="element-125">
          {projects.map((project, index) => <MotionBox key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-126">
              <ProjectCard title={project.title} description={project.description} link={project.link} tools={project.tools} gradient={project.gradient} image={project.image} buildTime={project.buildTime} data-id="element-127" />
            </MotionBox>)}
        </SimpleGrid>
      </MotionBox>
    </Box>;
}